<div class="reward-detail-container">
  <app-mobile-header [title]="'label.voucher'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickClose()"></app-mobile-header>

  <i class="icon-share" (click)="onShowShare();" *ngIf="!appLinkTokenResponse"></i>

  <div class="rewardDetail-content">
    <div class="image-container">
      <img [src]="imageData" onerror="this.src='assets/image-unavailable.svg'" alt="membership voucher" loading="lazy">
    </div>

    <div class="voucher-header">
      <h1 class="vchTypTitle">{{vchTypTitle }}</h1>
      <p>{{ vchTypDesc }}</p>

      <div class="progressbar-container" *ngIf="exploreReward && issueLimitMode > 0">
        <p-progressBar [value]="totalIssuedPercentage" [showValue]="false"></p-progressBar>
        <p>{{ totalIssuedPercentage }}% <span class="text-claimed" *ngIf="cardType !== cardTypes.claimed">{{
            "label.claimed" | translate }}</span>
          <span *ngIf="cardType === 'claimed'">{{ "label.used" | translate }}</span>
        </p>
      </div>
    </div>

    <div class="validData-container"
      *ngIf="(isUserClaimed? effectiveDate: claimStartDate) || (isUserClaimed? expiryDate: claimEndDate)">
      <h1 class="ttile">{{'label.valid.date' | translate}}</h1>
      <div class="validData-desc">
        <span class="label" *ngIf="(isUserClaimed? effectiveDate: claimStartDate)">{{'label.from' | translate}}</span>
        <span *ngIf="(isUserClaimed? effectiveDate: claimStartDate)">{{ (isUserClaimed? effectiveDate: claimStartDate) |
          date: "dd/MM/yyyy" }}</span>
        <span
          [ngClass]="{'label' : isUserClaimed? expiryDate: claimEndDate && !(isUserClaimed? effectiveDate: claimStartDate)}"
          *ngIf="(isUserClaimed? expiryDate: claimEndDate)">{{'label.until' | translate}}</span>
        <span *ngIf="(isUserClaimed? expiryDate: claimEndDate)">{{ (isUserClaimed? expiryDate: claimEndDate) | date:
          "dd/MM/yyyy" }}</span>
      </div>
    </div>

    <div class="term-container" *ngIf="termsData">
      <div [innerHtml]="termsData" class="term-desc"></div>
    </div>
  </div>

  <ng-template [ngIf]="!fullpagePromotion">
    <app-bottom-action-footer [buttonName]="'button.fully.claimed'" [disbaleButton]="true"
      *ngIf="cardType == 'full'"></app-bottom-action-footer>
    <app-bottom-action-footer [buttonName]="'label.claimed'" [disbaleButton]="true"
      *ngIf="cardType == cardTypes.claimed"></app-bottom-action-footer>
    <app-bottom-action-footer [buttonName]="'button.use.show.qr'" (click)="onUse()"
      *ngIf="cardType == cardTypes.use"></app-bottom-action-footer>
    <app-bottom-action-footer [buttonName]="'button.go.to.store'" (click)="onNavigate()"
      *ngIf="cardType == cardTypes.store"></app-bottom-action-footer>
    <app-bottom-action-footer [buttonName]="'button.claimable'" (click)="onClaim()"
      *ngIf="cardType == cardTypes.claim"></app-bottom-action-footer>

    <!-- for cart-->
    <app-bottom-action-footer [buttonName]="'button.select'" (click)="onSelect(true)"
      *ngIf="cardType == cardTypes.singleSelect && !active"></app-bottom-action-footer>
    <app-bottom-action-footer [buttonName]="'button.remove'" (click)="onSelect(false)"
      *ngIf="cardType == cardTypes.singleSelect && active"></app-bottom-action-footer>
  </ng-template>

  <ng-template [ngIf]="fullpagePromotion && exploreReward?.storeResponseList.length > 0">
    <app-bottom-action-footer [buttonName]="'button.go.to.store'" (click)="onNavigate()"></app-bottom-action-footer>
  </ng-template>
</div>